<!-- 创建时间2022/07/01 17:12:12 -->
<!-- 创建人：zhu xiao hu -->
<!-- 组件描述：鉴定-鉴定方式 -->
<template>
  <div>
    <yxt-card class="yxtbiz-appraise-mode" shadow="never">
      <yxt-form ref="dataForm"  :model="dataForm" :rules="rules" label-position="left" label-width="77px" class="yxtbiz-appraise-form">
        <!--        是否自动评估-->
        <yxt-form-item :label="$t('pc_biz_appraise_auto_result' /*自动评估*/)">
          <yxt-switch v-model="dataForm.autoPass" :active-text="$t('pc_biz_appraise_close_explain' /*若关闭，需手动鉴定合格*/)" @change="handleChangeEnable"/>
        </yxt-form-item>

        <!--        通过率/总分-->
        <yxt-form-item prop="num">
         <!--          总分不低于{}分 时为合格,翻译时大括号中间的只能为0，不能为n，不然不生效-->
          <language-slot :lang-key="dataForm.type===1?'pc_biz_appraise_pass_over_percentage':'pc_biz_appraise_pass_over_score'">
            <yxt-input-number class="yxtbiz_appraise_num_input mr6" size="large" :disabled="!dataForm.autoPass" v-model="dataForm.num" @change="handleChangeNum" :precision='1' :min="dataForm.type===1?0.1:0" :max="100" @input="handleChangeNum"/>
          </language-slot>
        </yxt-form-item>

        <!-- 选择模板 -->
        <yxt-form-item :label="$t('pc_biz_appraise_choose_template' /*选择模板*/)" prop="template" class="yxtbiz-appraise-choose-template">
          <yxt-button type="primary" size="large" class="yxtbiz-appraise-questionnaire-btn" @click="chooseFormWork" :disabled="!!isPublished">{{$t('pc_biz_appraise_choose_template'/*选择模板*/)}}</yxt-button>

          <ul v-if="dataForm.template&&dataForm.template.id">
            <li class="yxtbiz_appraise_file_preview">
              <yxt-svg
                :remote-url="`${$staticBaseUrl}assets/24ea854a/176467f6/`"
                icon-class="file_preview"
                width="24px"
                height="24px"
                class="yxtbiz_appraise_file_icon"
              /> 
              <span>{{dataForm.template.name}}</span>
              <i class="yxt-icon-close" @click="handleDelQuestion()" v-show="!isPublished"></i>
            </li>
          </ul>
        </yxt-form-item>
      </yxt-form>
    </yxt-card>
    <!--    选择模板弹出框-->
    <choose-formwork-drawer ref="choose-formwork" @formWork="handleChooseFormwork" :type="dataForm.type"/>
  </div>
</template>

<script>
import chooseFormworkDrawer from './chooseFormworkDrawer';
import LanguageSlot from './LanguageSlot';
import { enmuFunctions } from '../../../function-points';
import { getFunStatus } from '../../../common-util/factorUtils';
export default {
  name: 'appraiseMode',
  props: {
    operateType: {
      type: Number,
      default: 1
    },
    isPublished: {
      type: Number,
      default: 0
    }
  },
  components: {
    chooseFormworkDrawer, LanguageSlot
  },
  data() {
    return {
      value: false,
      dataForm: {type: 1, autoPass: false, num: 60, template: undefined},
      rules: {
        template: [{ required: true, message: this.$t('pc_biz_appraise_please_choose_template' /* 请选择模板*/), trigger: 'change' }]
      }
    };
  },
  watch: {
    'dataForm.template': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.$refs['dataForm'].clearValidate('template');
          });
        }
      }
    }
  },
  computed: {
    forbidFormWork() {
      let statusDis = false;
      if (getFunStatus(enmuFunctions.O2O_SURVEY_APPRAISAL).disabled || [0, 1].indexOf(getFunStatus(enmuFunctions.O2O_SURVEY_APPRAISAL)) > -1) {
        statusDis = true;
      }
      return statusDis;
    }
  },
  methods: {
    open(data) {
      this.dataForm = data;
    },
    // 打开抽屉
    chooseFormWork() {
      this.$refs['choose-formwork'].init({ ...this.dataForm });
    },
    // 必填项验证
    validateHandle() {
      let status = null;
      this.$refs['dataForm'].validate((val) => {
        status = !!val;
      });
      return status;
    },
    // 选择分数
    handleChangeNum(value) {
      this.dataForm = Object.assign(this.dataForm, {num: value});
      // Object.assign(this.dataForm, {num: value});
      this.handlePostData();
    },
    // 自动模板
    handleChooseFormwork(value) {
      Object.assign(this.dataForm, {template: value});
      this.handlePostData();
    },
    // 选择自动评估
    handleChangeEnable(value) {
      this.dataForm = Object.assign(this.dataForm, {autoPass: value});
      // Object.assign(this.dataForm, {autoPass: value});
      this.handlePostData();
    },
    // 删除模板
    handleDelQuestion(index) {
      this.dataForm.template = undefined;
      this.handlePostData();
    },
    handlePostData() {
      this.$emit('refreshMode', this.dataForm);
    }
  }
};
</script>

<style scoped>

</style>